import { CircularProgress, styled } from "@mui/material";
import { useThemeProps } from "@mui/material/styles";

export function Loading() {
    const spinnerProps = useThemeProps({ props: {}, name: "MuiAppLoadingSpinner" });

    return (
        <LoadingRoot>
            <AppLoadingSpinner {...spinnerProps} />
        </LoadingRoot>
    );
}

const AppLoadingSpinner = styled(CircularProgress, {
    name: "MuiAppLoadingSpinner",
    slot: "root",
})(() => ({}));

const LoadingRoot = styled("div", {
    name: "MuiAppLoading",
    slot: "root",
})(() => ({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
}));
